var _defs, _path, _path2, _g, _path3, _polygon, _path4, _polygon2, _polygon3, _rect, _polygon4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirminghamPhoenix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff4b32;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1080,540c0,298.24-241.76,540-540,540S0,838.24,0,540,241.76,0,540,0s540,241.76,540,540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580.39,544.96l62.36-103.58,62.37,103.58h-124.73ZM374.88,544.96l62.37-103.58,62.36,103.58h-124.73ZM540,577.03l77.54,81.27h255.12l-174.84-290.38-107.04-.08-50.78,72.79-50.78-72.79-107.04.08-174.85,290.38h255.13l77.54-81.27ZM380.13,858.1l159.87-210.12,159.87,210.12-159.87-64.2-159.87,64.2ZM617.17,320.03l-77.17-117.05-77.17,117.05h154.34Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.56,358.69l17.81,9.18,12.7-24.64c4.04-7.84,2.98-13.49-2.84-16.49-5.94-3.06-10.93-.53-14.97,7.31l-12.7,24.64ZM115.54,342.69l15.68,8.09,12.47-24.19c3.35-6.5,2.85-11.58-2.53-14.35-5.49-2.83-9.75-.35-13.15,6.26l-12.47,24.19ZM90.55,353.49l23.67-45.92c8.95-17.36,22.25-22.27,35.36-15.51,8.29,4.27,10.78,12.64,10.13,19.4,5.93-5.73,15.55-8.71,26.08-3.28,13.77,7.1,17.83,21.24,8.36,39.61l-24.08,46.71-79.52-41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 182.3,
    y: 224.49,
    width: 21.42,
    height: 89.46,
    transform: "translate(-137.96 255.49) rotate(-51.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.4,201.61l12.54,14.31,21.6-18.93c5.97-5.23,7.12-10.42,3.05-15.07-4.48-5.12-9.52-4.56-15.59.76l-21.61,18.94ZM190.16,201.89l39.42-34.55c14.88-13.03,30.28-13.8,42.49.12,8.22,9.38,9.13,19.98,3.65,29.97l39.16,14.1-16.96,14.86-36.64-13.13-18.48,16.19,22.42,25.59-16.11,14.12-58.96-67.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "360.99 152.05 357.27 90.16 384.47 77.54 422.13 158.68 403.39 167.38 374.9 106.01 379.67 178.53 366.64 184.58 314.89 134.42 343.16 195.33 325.33 203.61 287.67 122.46 316.13 109.26 360.99 152.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 435.19,
    y: 65.23,
    width: 21.42,
    height: 89.46,
    transform: "translate(-13.19 97.42) rotate(-12.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "575.81 144.1 558.43 144.43 508.49 83.51 509.67 145.11 488.76 145.51 487.05 56.07 511.36 55.6 554.74 109.59 553.69 54.79 574.1 54.4 575.81 144.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.96,159.01c-29.57-7.43-43.98-30.27-37.1-57.64,6.54-26.03,29.81-40.06,56.32-33.41,26.89,6.75,33.84,25.12,33.86,35.39l-21.87-5.49c-1.68-3.15-5.89-9.14-16.52-11.81-14.82-3.59-26.96,5.44-30.76,20.59-4.05,16.13,3.21,30.17,21.05,34.65,9.29,2.33,16.16,1.85,19.28.81l3.59-14.3-27.38-6.87,4.27-16.98,47.29,11.87-10.22,40.69c-5.96,3.05-21.16,7.68-41.81,2.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "770.26 175.18 732.17 153.71 714.78 184.55 696.12 174.03 740.05 96.1 758.71 106.62 741.45 137.24 779.54 158.71 796.8 128.09 815.35 138.54 771.43 216.48 752.87 206.02 770.26 175.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M849.98,243.46l12.47-32.09-31.87,13.01,19.4,19.08ZM842.91,261.61l-30.36-29.86-15.63,6.37-15.36-15.11,90.75-36.39,15.63,15.37-34.97,91.25-16.17-15.9,6.11-15.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "913.98 333.46 975.45 325.26 990.01 351.48 911.8 394.92 901.77 376.86 960.92 344 888.93 354 881.95 341.45 928.23 286.19 869.52 318.8 859.98 301.62 938.19 258.17 953.42 285.6 913.98 333.46"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.42,840.34l-13.57,15.59,21.86,19.03c6.18,5.38,11.87,4.98,16,.23,4.39-5.04,3.84-10.36-2.43-15.82l-21.86-19.03ZM250.6,812.29l39.44,34.33c15.3,13.32,17.61,28.7,5.29,42.86-12.16,13.97-28.04,14.18-43.34.86l-23.38-20.35-20.68,23.76-16.06-13.98,58.74-67.47Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "361.98 953.38 322.72 934.13 307.13 965.91 287.9 956.48 327.29 876.16 346.52 885.59 331.05 917.16 370.3 936.41 385.78 904.85 404.9 914.22 365.51 994.54 346.39 985.17 361.98 953.38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.45,977.27c2.77-14.74-4.65-28.44-20.14-31.35-15.48-2.91-27.47,7.02-30.27,21.88-2.81,14.98,4.78,28.46,20.26,31.37,15.48,2.91,27.35-7.04,30.14-21.9M411.63,963.77c5.07-27,28.85-41.63,55.23-36.68,26.26,4.93,43.1,27.2,38.03,54.2-5.03,26.75-28.85,41.63-55.1,36.7-26.5-4.98-43.2-27.35-38.15-54.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "529.81 936.93 604.49 931.99 605.66 949.6 552.35 953.12 553.41 969.21 585.22 967.11 586.41 985.09 554.6 987.19 555.86 1006.3 614.07 1002.46 615.29 1020.94 535.7 1026.2 529.81 936.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "734.55 986.64 718.05 992.12 652.25 948.82 671.7 1007.28 651.86 1013.88 623.61 929 646.69 921.33 704.16 959.96 686.86 907.96 706.22 901.52 734.55 986.64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 746.96,
    y: 877.87,
    width: 21.42,
    height: 89.46,
    transform: "translate(-357.5 496.39) rotate(-29.69)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "835.83 885.03 835.96 924.98 816.95 941.33 816.67 881.9 759.46 872.79 780.48 854.7 816.47 860.8 816.29 823.89 835.68 807.2 835.8 863.95 895.27 873.94 875.12 891.28 835.83 885.03"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirminghamPhoenix);
export default __webpack_public_path__ + "static/media/birmingham-phoenix.e0247e37.svg";
export { ForwardRef as ReactComponent };